module.exports = __webpack_public_path__ + "static/media/redemption-config-banner.fa326a7c.svg";